var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.link,"title":_vm.title}},[_c('nuxt-img',{attrs:{"width":"40","src":`/images/flags/${_vm.country}.svg`}}),_vm._v(" "),_c('div',[_c('span',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('span',[_vm._v("in "+_vm._s(_vm.countryName))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }